var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Titlebar',[_c('h5',{staticClass:"title is-5 is-marginless",attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t('document.title')))])])}
var staticRenderFns = []

export { render, staticRenderFns }